var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "game-tab-wrapper", class: { fixed: _vm.isFixedGameTab } },
    [
      !_vm.loading
        ? _c("div", { staticClass: "game-tab", class: _vm.language }, [
            _c(
              "div",
              {
                staticClass: "tab-btn hot-btn",
                class: { active: _vm.currentGameTab === "hot" },
                style: {
                  width: _vm.tabBtnWidth,
                  "justify-content": _vm.tabBtnJustifyContent,
                },
                on: {
                  click: function ($event) {
                    return _vm.setTab("hot")
                  },
                },
              },
              [_c("span", [_vm._v(_vm._s(_vm.$ln("熱門")))])]
            ),
            _vm.tabGameList.fish && _vm.tabGameList.fish.length !== 0
              ? _c(
                  "div",
                  {
                    staticClass: "tab-btn fish-btn",
                    class: { active: _vm.currentGameTab === "fish" },
                    style: {
                      width: _vm.tabBtnWidth,
                      "justify-content": _vm.tabBtnJustifyContent,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setTab("fish")
                      },
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$ln("捕魚機")))])]
                )
              : _vm._e(),
            _vm.tabGameList.slot && _vm.tabGameList.slot.length !== 0
              ? _c(
                  "div",
                  {
                    staticClass: "tab-btn slot-btn",
                    class: { active: _vm.currentGameTab === "slot" },
                    style: {
                      width: _vm.tabBtnWidth,
                      "justify-content": _vm.tabBtnJustifyContent,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setTab("slot")
                      },
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$ln("老虎機")))])]
                )
              : _vm._e(),
            _vm.tabGameList.arcade && _vm.tabGameList.arcade.length !== 0
              ? _c(
                  "div",
                  {
                    staticClass: "tab-btn arcade-btn",
                    class: { active: _vm.currentGameTab === "arcade" },
                    style: {
                      width: _vm.tabBtnWidth,
                      "justify-content": _vm.tabBtnJustifyContent,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setTab("arcade")
                      },
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$ln("街機")))])]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }